import { Note, QueryParams } from "@/sharedTypes";
import { baseApi } from "./baseApi";
import { flattenQueryParams } from "@/utils/requestUtils";

const noteTag = "Note";

const noteApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createNote: builder.mutation({
      query: (noteData: Note) => ({
        url: "/gw/notes",
        method: "POST",
        body: noteData,
      }),
      invalidatesTags: [noteTag],
    }),
    getTicketNotes: builder.query({
      query: ({
        ticketId,
        queryParams,
      }: {
        ticketId: string;
        queryParams: Record<string, any>;
      }) => {
        const queryString = queryParams
          ? `&${new URLSearchParams(flattenQueryParams(queryParams)).toString()}`
          : "";
        return `/gw/notes?ticket_id=${ticketId}&${queryString}`;
      },
      providesTags: [noteTag],
    }),
    deleteNote: builder.mutation({
      query: (noteId: number) => ({
        url: `/gw/notes/${noteId}`,
        method: "DELETE",
      }),
      invalidatesTags: [noteTag],
    }),
    updateNote: builder.mutation({
      query: ({
        noteId,
        noteData,
      }: {
        noteId: number;
        noteData: { note_body: string; is_visible_to_client: boolean };
      }) => ({
        url: `/gw/notes/${noteId}`,
        method: "PUT",
        body: noteData,
      }),
      invalidatesTags: [noteTag],
    }),
  }),
});

export const {
  useCreateNoteMutation,
  useGetTicketNotesQuery,
  useDeleteNoteMutation,
  useUpdateNoteMutation,
} = noteApi;

export default noteApi;
